/** * 数据字典 */
<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" icon="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="字典编号：">
					<el-input clearable v-model="formInline.dicCode" size="small" placeholder="请输入字典编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<!--列表-->
			<STable :columns="columnsData" :data="listData" :loading="loading" @get-data="getListData" @handle-command="handleCommand" @row-click="handleRowClick"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<edit ref="edit"></edit>
		<childList ref="childList"></childList>
	</div>
</template>

<script>
import { GetDicDataList, DeleteDicData } from "../../../api/dicDataApi.js";
import edit from "./edit.vue";
import childList from "./childList.vue";
export default {
	components: {
		edit,
		childList
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "数据字典"
				}
			],
			pageShow: true,
			loading: false, //是显示加载
			listData: [], //主页面数据
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				dicCode: ""
			},
			// 分页参数
			pageparm: {
				currentPage: 1,
				pageSize: 15,
				total: 0
			},
			columnsData: [], //显示列

			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "dicCode",
					label: "字典编号",
					isKeep: true
				},
				{
					prop: "dicText",
					label: "字典名称",
					isKeep: true
				},
				{
					prop: "desc",
					label: "字典描述"
				},
				{
					prop: "seq",
					label: "显示顺序"
				},
				{
					operation: true,
					isKeep: true,
					label: "操作",
					btnGroup: [
						{
							icon: "el-icon-view",
							name: "查看",
							type: "1"
						},
						{
							icon: "el-icon-plus",
							name: "子节点",
							type: "3",
							btnType: "primary"
						},
						{
							icon: "el-icon-delete",
							name: "删除",
							type: "4",
							btnType: "danger"
						}
					]
				}
			]
		};
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 重置
		clearAll() {
			this.formInline.pageIndex = 1;
			this.formInline.dicText = "";
			this.formInline.dicCode = "";
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		inputChange() {
			this.search();
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.title = "";
			this.$refs.edit.handleEdit(row);
		},

		addModule(row) {
			this.$refs.edit.title = "新增子节点";
			this.$refs.edit.handleEdit(row);
		},
		handleEdit(row) {
			this.$refs.edit.title = "";
			this.$refs.edit.handleEdit(row);
		},
		// 显示子节点界面
		openChildWin(row) {
			this.$refs.childList.openChildWin(row);
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetDicDataList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("加载失败，请稍后再试！");
				});
		},
		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.openChildWin(command.rowData);
					break;
				case "3":
					this.addModule(command.rowData);
					break;
				case "4":
					this.deleteData(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		// 删除
		deleteData(row) {
			var parmar = {
				keyIds: [row.keyId]
			};
			this.$confirm("确定要删除<" + row.dicText + ">吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					DeleteDicData(parmar)
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "已删除"
								});
								this.loading = true;
								setTimeout(() => {
									this.getListData();
									this.$refs.childList.getListData2();
								}, 500);
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("删除失败，请稍后再试！");
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		},
		// 分页插件事件
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>
<style scoped></style>
